import { Component } from '@angular/core';

@Component({
  selector: 'lib-web-reader-lib',
  imports: [],
  template: `
    <p>
      web-reader-lib works!
    </p>
  `,
  styles: ``,
})
export class WebReaderLib {

}
